import React from 'react';
import { Outlet } from 'react-router-dom';
import { logoUrl, photoUrl, useSite } from '../utils/site';

export function AuthLayout() {
  const site = useSite();
  // Optional picture behind the green panel (Administration -> Appearance -> Photos).
  const picture = photoUrl(site, 'login.picture');
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-surface-subtle">
      <div className="hidden lg:flex lg:w-1/2 bg-brand-green-800 text-white flex-col justify-between p-10 xl:p-14 relative overflow-hidden">
        {picture && (
          <>
            <img src={picture} alt="" className="absolute inset-0 h-full w-full object-cover" aria-hidden="true" />
            <div className="absolute inset-0 bg-brand-green-900/70" aria-hidden="true" />
          </>
        )}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_20%_20%,white,transparent_45%)]" aria-hidden="true" />
        <div className="flex items-center gap-3 relative">
          <img src={logoUrl(site)} alt="Logo" className="h-16 w-auto object-contain shrink-0 rounded bg-white p-1" />
          <div>
            <p className="text-xl font-bold leading-tight">Sri KalpaGavya</p>
            <p className="text-brand-green-100 text-sm">Integrated Livestock Management System</p>
          </div>
        </div>
        <div className="relative">
          <p className="text-3xl xl:text-4xl font-bold leading-snug max-w-md">
            {site.login_tagline}
          </p>
          <p className="text-brand-green-100 mt-4 max-w-md">
            One system for livestock, health, breeding, production, utilities and finance —
            built for operators in the field and management in the office.
          </p>
        </div>
        <p className="text-brand-green-200 text-secondary relative">
          &copy; {new Date().getFullYear()} Sri KalpaGavya Farms. All rights reserved.
        </p>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
